<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2021-01-15 11:46:12
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @LastEditTime: 2021-01-15 13:03:04
 * @Description: 
 * @FilePath: \hsylc2021\src\components\Loading\index.vue
-->
<template>
  <div class="component-loading">
    <i></i>
    <div class="text-loading t-ct color-gray-1">加载中...</div>
  </div>
</template>
<script>
export default {
  name: 'Loading'
};
</script>
<style lang="less" scoped>
.component-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .text-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: 40px;
    transform: translateX(-50%);
  }
  i {
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    width: 60px;
    height: 60px;
    margin-top: -30px;
    margin-left: -30px;
    background-image: @icon-loading;
    background-size: 100% 100%;
    animation: aniLoading 2s linear infinite;

    @keyframes aniLoading {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}
</style>
